module.exports = __webpack_public_path__ + "img/img22.b8d0db10.jpg";